import React, { useState, useEffect, FC } from 'react'

import { MagicLinkIcon } from '../../../components/Icons'
import { LogInHeader, ModalText } from '../../../components/Typography'

import { Wrap } from './styled'

import { EmailForSignInKey } from 'src/constants/localStorageKeys'

export const MagicLink: FC = () => {
  const [email, setEmail] = useState('')

  useEffect(() => {
    const getEmail = window.localStorage.getItem(EmailForSignInKey)
    getEmail && setEmail(getEmail)
  }, [])

  return (
    <Wrap>
      <MagicLinkIcon />
      <LogInHeader>Check you email!</LogInHeader>
      <ModalText>
        We sent an email to you at {email}.
        <br />
        It has a magic link that’ll sign you in.
      </ModalText>
    </Wrap>
  )
}
